import { api } from 'api'
import { useQuery } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useAccessListFetch = () => {
  const response = useQuery({
    queryKey: ['accessList'],
    queryFn: () => api.keycloak.fetchUserList(),
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить список пользователей',
      type: 'error',
    })
  }

  return response
}
